import cls from 'classnames';
import {
  ReactNode,
  useEffect,
  useState
} from 'react';
import styles from './styles.module.scss';

interface AnimatedElementProps {
  children: ReactNode;
  delay: number;
  className?: string;
}

const AnimatedElement = ({
    children, delay, className 
}: AnimatedElementProps) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, delay);

        return () => clearTimeout(timer);
    }, [delay]);

    return (
        <div className={cls(styles.animatedElement, { [styles.show]: show }, className)}>
            {children}
        </div>
    );
};

export default AnimatedElement;